import React, { useState } from "react";
import { Form, OverlayTrigger, Tooltip } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";

const ONBOARDING_QUESTION = "What brings you to simply?";

function ViewUser({ user }) {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const answers = (Array.isArray(user?.answeredList) ? user.answeredList : [])
    .map((item) => (typeof item === "string" ? item : item?.name ?? item?.answer ?? ""))
    .filter(Boolean);

  return (
    <>
      <OverlayTrigger
        key="top"
        placement="top"
        overlay={<Tooltip id="tooltip-top">View</Tooltip>}
      >
        <img
          src="/images/png/view.png"
          onClick={handleShow}
          className="pointer"
          width={35}
          alt="action"
        />
      </OverlayTrigger>

      <Modal
        show={show}
        className="custom-modal"
        size="lg"
        centered
        scrollable
        onHide={handleClose}
      >
        <Modal.Header closeButton>
          <Modal.Title>View User</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row g-3">
            <div className="col-lg-6">
              <Form.Label className="mb-0">Name</Form.Label>
              <p>
                {user.firstName ? `${user.firstName} ${user.lastName}` : "-"}
              </p>
            </div>
            {/* <div className="col-lg-6">
                            <Form.Label className='mb-0'>Birthdate</Form.Label>
                            <p>{user.dob ? new Date(user.dob).toISOString().split("T")[0] : "-"}</p>
                        </div> */}
            <div className="col-lg-6">
              <Form.Label className="mb-0">Email</Form.Label>
              <p>{user.email ? user.email : "-"}</p>
            </div>
            <div className="col-lg-6">
              <Form.Label className="mb-0">Status</Form.Label>
              <p>{user.isActive === 1 ? "Active" : "Inactive"}</p>
            </div>
            {/* <div className="col-6">
                            <Form.Label className='mb-0'>Phone</Form.Label>
                            <p>{user.contactNo ? user.contactNo : "-"}</p> */}
            {/* </div>
                        <div className="col-6">
                            <Form.Label className='mb-0'>Zip Code</Form.Label>
                            <p>{user.zipCode ? user.zipCode : "-"}</p>
                        </div> */}
            <div className="col-6">
              <Form.Label className="mb-0">Subscribed</Form.Label>
              <p>{user.subscription === true ? "true" : "false"}</p>
            </div>
            <div className="col-6">
              <Form.Label className="mb-0">Completed Tips</Form.Label>
              <p>{user?.tipsCompleted || 0}</p>
            </div>
            <div className="col-6">
              <Form.Label className="mb-0">Device Type</Form.Label>
              <p>{user?.deviceType || "-"}</p>
            </div>
            {
              user?.answeredList?.length > 0 && (
            <div className="col-12">
              <Form.Label className="mb-2">Questions & Answers</Form.Label>
              <div className="qa-card">
                <div className="qa-item">
                  <span className="qa-label">Question:</span>
                  <p>{ONBOARDING_QUESTION}</p>
                </div>
                <div className="qa-item">
                  <span className="qa-label">Answer:</span>
                  {answers.length > 0 ? (
                    <ul className="qa-answers">
                      {answers.map((answer, index) => (
                        <li key={index}>{answer}</li>
                      ))}
                    </ul>
                  ) : (
                    <p>-</p>
                  )}
                </div>
              </div>
            </div>
            )
            }
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default ViewUser;
